<template>
<div class="card mb-0">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="card-title mb-0">Opportunity Details</h5>
    </div>
    <div class="card-body position-relative">
        <div  class="row g-4"> 
        <div class="col-12">
            <div class="d-flex align-items-center">
            <img @click="showProfileImg(item.company_logo)" 
            class="avatar me-3 rounded-circle cursor-pointer" :src="absoluteUrl(item.company_logo)" />
            <div>
                <label class="small text-muted">Opportunity ID</label>
                <p class="mb-0">{{ item.friendly_id }}</p>
            </div>
            </div>
        </div>
        <div class="col-lg-6">
            <label class="small text-muted">Title</label>
            <p class="mb-0">{{ item.title }}</p>
        </div>
        <div class="col-lg-6">
            <label class="small">Company Name</label>
            <h6 class="mb-0">{{ item.company_name }}</h6>
        </div>
        <div class="col-sm-6">
            <label class="small text-muted">Contact Email</label>
            <p class="mb-0">{{ item.email }}</p>
        </div>
        <div class="col-sm-6">
            <label class="small text-muted">Contact Phone Number</label>
            <p class="mb-0">{{ item.mobile }}</p>
        </div>
        <div class="col-sm-6">
            <label class="small text-muted">Application Deadline</label>
            <p class="mb-0">{{ $filters.date(item.closing_date, 2) }}</p>
        </div>
        <div class="col-sm-6">
            <label class="small text-muted">Posted On</label>
            <p class="mb-0">{{ $filters.date(item.started_at, 1) }}</p>
        </div>
        <div class="col-12">
            <label class="small text-muted">Contact Address </label>
            <CommonAddress :item="item.address" />
        </div>
        <div v-if="item.qualifications.length" class="col-12">
            <label class="small text-muted">Qualifications required </label>
            <CommonQualificationList :items="item.qualifications"/>
        </div>
        <div v-if="item.skills.length" class="col-12">
            <label class="small text-muted">Skills required </label>
            <CommonSkillList :items="item.skills"/>
        </div>
        <div v-if="item.courses.length" class="col-12">
            <label class="small text-muted">Required course(s) of study </label>
            <CommonCourseList :items="item.courses"/>
        </div>
        <div class="col-12">
            <label class="small text-muted">Description </label>
            <div v-html="item.description" class="">
            </div>
        </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props:{
        item:{
            type:Object,
            required: true
        }
    }, 
}
</script>

<style>

</style>